import { EventDetailItemProps } from "./types";

export const EventDetailItem = ({ label, value }: EventDetailItemProps) => (
  <div className="flex justify-between items-center py-2 border-b border-stone-700/20">
    <span className="text-amber-200/60 font-light">{label}</span>
    <span className="text-white/90 font-medium">{value}</span>
  </div>
);
